import { MessageMedium } from 'constants/messageMediums';

/**
 * @deprecated
 * Updated code should pull `MessageMedium` from `constants/messageMediums`
 */
export { MessageMedium } from 'constants/messageMediums';

export type Channel = {
  id: number;
  createdAt: number;
  updatedAt: number;
  projectId: number;
  creatorUserId: string;
  name: string;
  channelType: string;
  messageMedium: MessageMedium;
};

export enum ChannelType {
  marketing = 'Marketing',
  transactional = 'Transactional',
}
